export const SET_COMPANY_LOGIN_STORE = 'SET_COMPANY_LOGIN_STORE';
